import { YooKassaSuccessPayment } from './YooKassaSuccessPayment.main';

export { YooKassaSuccessPayment };
